import React from 'react'
import { useDispatch } from 'react-redux'
import { useSelector, shallowEqual } from 'react-redux'
import { Link } from 'react-router-dom'
import './index.scss'
import { Icon, Switch } from '@ui-pc'
import { getRelativeUrl } from '@utils'

interface Props {
  item: any
  readonly?: boolean
  currentCode?: string
  couponStyle?: number // 不同状态优惠券展示样式 1:可用&不需要登录 2:可用&需要登录 3:不可用&需要登录 4:不可用&不需要登录 5:已领取完
  clickChange?: (code: string) => void
}

const CouponItem: React.FC<Props> = ({
  item,
  readonly,
  currentCode,
  couponStyle = 1,
  clickChange
}) => {
  // readonly: 只读
  // readonly && !item.isAvailable: 只读&不满足门槛
  const dispatch = useDispatch()
  const isLogin = useSelector((state: any) => state.app.isLogin, shallowEqual)

  const showLoginModal = () => {
    dispatch({
      type: 'login/triggleLogin',
      payload: true
    })
  }

  const handleClick = (style: number, code?: string) => {
    if (style === 1) {
      clickChange(code)
    }
  }

  return (
    <section
      className={`coupon-box-item ${`coupon-style${couponStyle}`} ${
        readonly ? 'readyonly' : ''
      } ${
        (readonly && !item.isAvailable) || [3, 4].includes(couponStyle)
          ? 'not-available-item'
          : ''
      } ${couponStyle === 5 ? 'coupon-invalid-item' : ''}`}>
      <div
        className="coupon-box"
        onClick={() => {
          handleClick(couponStyle, item.couponCode)
        }}>
        <div className="box-coupon">
          <span className="box-text">
            {item.discount || item.couponAmount} OFF
          </span>
          <Switch either={[2, 3].includes(couponStyle)}>
            <span className="new-label">New Users</span>
          </Switch>
        </div>
        <div className="box-coupon-desc">
          <span className="desc-code text1">Code:&nbsp;{item.couponCode}</span>
          <span className="desc-order">
            Orders over {item.couponMinimumOrder}
          </span>
          <Switch either={[2, 3].includes(couponStyle)}>
            <span className="desc-new-user">
              Coupons available for new users
            </span>
            <span className="desc-time">
              {item.couponStartDate} - {item.couponExpireDate}
            </span>
          </Switch>
          {/* 优惠券中心 */}
          <Switch either={!readonly && couponStyle !== 5}>
            <>
              {/* 1:可用&不需要登录 2:可用&已登录 */}
              <Switch
                either={couponStyle === 1 || (isLogin && couponStyle === 2)}>
                <div className="checked">
                  <Switch either={item.couponCode === currentCode}>
                    <Icon
                      className="checked-icon"
                      customSrc={'icon-ic_gou'}
                      size={20}
                    />
                    <span className="box-radio"></span>
                  </Switch>
                </div>
              </Switch>
              {/* 2:可用&需要登录 3:不可用&需要登录 */}
              <Switch either={!isLogin && [2, 3].includes(couponStyle)}>
                <div className="sign-get sign-item" onClick={showLoginModal}>
                  Sign in to Get
                </div>
              </Switch>
            </>
          </Switch>

          {item?.couponUrl && (
            <Link
              className="desc-coupon-url"
              to={getRelativeUrl(item?.couponUrl)}
              target="_blank">
              Pick More
            </Link>
          )}
        </div>
      </div>
      <Switch either={!!item.showUseDesc}>
        <div className="box-instruction">
          <span
            className="instruction-tips"
            dangerouslySetInnerHTML={{ __html: item.showUseDesc }}></span>
        </div>
      </Switch>
    </section>
  )
}

export default CouponItem
